(function () {
  function initBlogLayout() {
    var sections = document.querySelectorAll('[data-blog-layout-section]');
    if (!sections.length) return;

    var nestedContainer = document.querySelector('.main-content > .container');
    if (nestedContainer && !nestedContainer.classList.contains('blog-layout') && !nestedContainer.classList.contains('article-layout')) {
      nestedContainer.classList.remove('container');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogLayout);
  } else {
    initBlogLayout();
  }
})();
